export const getStepCampaignSettingsStyles = (_, { palette = {} }) => ({
  urlOptionsContainer: {
    maxWidth: 435,
  },
  moreBasicCampaignSection: {
    '& .advanced-scheduling-grid': {
      '& .alert-info-inline': {
        '& a:focus': {
          outline: `1px solid ${palette.neutralSecondary}`,
        },
      },
    },
  },
  collapsiblePanel: {
    border: 'none',
    marginBottom: 'unset',
    backgroundColor: 'unset',

    '& .panel-heading': {
      padding: 0,
      borderBottom: 'none',
      marginBottom: 18,

      '& .panel-title': {
        fontSize: 18,
        '& > a': {
          marginLeft: '-8px', // compensate 8px padding on the left of icon
          color: palette.themePrimary,
          padding: 0,
          '&:hover, &:active': {
            color: palette.themeDarker,
            textDecoration: 'none',
            backgroundColor: 'unset',
          },
        },

        '& > a:after': {
          transform: 'rotate(180deg)',
        },

        '& > a.collapsed:after': {
          transform: 'rotate(90deg)',
        },
      },
    },

    '& .panel-collapse': {
      '& .panel-body': {
        padding: 0,
        overflow: 'hidden',
      },
    },
  },

  advancedBidStrategyContent: {
    '& .toggle-icon': {
      visibility: 'hidden',
    },
  },

  header: {
    marginBottom: 20,
  },
});
